import React from 'react';
import { Button, Container } from 'reactstrap';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import Img from 'react-image';
import { FadeLoader } from 'react-spinners';

import '../styles/App.css';
import '../styles/index.css';
import '../styles/sp-animate.css';
import { setHomeShowVideo } from '../actions/HomeActions';
import { getAbout } from '../actions/AboutActions';
import { getPlaces, getGeneros, getServices } from '../actions/PackageActions';
import { getPhotos } from '../actions/PhotosActions';
import {
  getVideos,
  getHomevideo,
  getVideosProm
} from '../actions/VideosActions';
import { setMenuOpen, setMenuHide } from '../actions/MenuActions';
import { getContactDB } from '../actions/ContactActions';
import spbrand from '../assets/images/spbrand.svg';
// import videosenior from '../assets/videos/seniorprom.mp4';
import VideoCoverFullScreen from '../components/VideoCoverFullScreen';
import noimage from '../assets/images/noimage.jpg';

class Home extends React.Component {
  state = {
    toggle: false,
    animate: false
  };

  componentWillMount() {
    ReactGA.pageview('/home');
    this.props.getHomevideo();
    this.props.getAbout();
    this.props.getPlaces();
    this.props.getGeneros();
    this.props.getServices();
    this.props.getPhotos();
    this.props.getVideos();
    this.props.getVideosProm();
    this.props.getContactDB();

    this.props.getHomevideo();

    // this.props.setMenuHide(true);

    // console.log('Home', this.props.location.state);
    if (this.props.location.state && this.props.location.state.animate) {
      this.setState({ animate: true });
      this.props.setMenuOpen(true);
    }
  }

  _disableVideo() {
    this.props.setMenuHide(false);
    this.setState({ animate: true });
    this.props.setHomeShowVideo(false);
    setTimeout(() => {
      this.props.setMenuOpen(true);
    }, 200);
  }

  _playVideo() {
    this.props.setMenuHide(true);
    this.props.setHomeShowVideo(true);
  }

  _getAnimate() {
    // return this.props.open ? 'appear' : 'vanish';
    return this.state.animate ? 'shake' : 'noshake';
  }

  _toggle() {
    this.setState({ toggle: !this.state.toggle });
    this.props.setMenuOpen(!this.props.open);
  }

  _start() {
    this.props.setMenuOpen(true);
    ReactGA.pageview('/home/comienzo');
  }

  _renderVideoPoster() {
    if (this.props.homeVideo.cover) {
      return (
        <div className="pre-videoshow" onClick={() => this._playVideo()}>
          <i className="ico-play-arrow">&nbsp;</i>
          <Img
            src={[this.props.homeVideo.cover, noimage]}
            loader={<FadeLoader color={"#462177"} loading={true} />}
          />
        </div>
      );
    }
  }

  // componentWillMount() {
  //   this.props.getHomevideo();
  // }

  _goScreen(screen) {
    //ReactGA.pageview('/Menu/' + screen);
    this.props.history.push(screen);
  }

  _goHome() {
    this.props.history.push({
      pathname: '/home',
      state: { animate: true }
    });
  }

  render() {
    if (this.props.showVideo === true) {
      return (
        <VideoCoverFullScreen
          src={this.props.homeVideo.url}
          finish={() => this._disableVideo()}
        />
      );
    } else if (this.props.showVideo === null) {
      return '';
    }

    return (
      <div className="bg-home">
        <div className={this._getAnimate()}>&nbsp;</div>

        <div className="obj-home">
          <Container>
            <img src={spbrand} width="200" alt="logotipo" />
            {/*{this._renderVideoPoster()}*/}
            <Button
              onClick={() => this._goScreen('package')}
              className="bt bt-primary m-t-30"
            >
              CREA TU PACKAGE
            </Button>
          </Container>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showVideo: state.HomeReducer.showVideo,
  homeVideo: state.VideosReducer.homeVideo
});

const mapActions = {
  getAbout,
  getPlaces,
  getGeneros,
  getServices,
  getPhotos,
  getHomevideo,
  getVideos,
  getVideosProm,
  setMenuOpen,
  getContactDB,
  setMenuHide,
  setHomeShowVideo
};

export default connect(mapStateToProps, mapActions)(Home);


// WEBPACK FOOTER //
// ./src/screens/Home.js